import { call, METHODS, signalToAxiosOptions } from '../http-client'
import { isProviderAPos } from '../Provider/Provider.service'

const ROUTE_PREFIX = 'companies';

export const getMerchantsOfCompany = async (companyId, signal = null) => {
    try {
        return await call(METHODS.GET, ROUTE_PREFIX, `${companyId}/pointofsales`, signalToAxiosOptions(signal));
    } catch (e) {
        console.error(`getMerchantsOfCompany error: ${e}`);
        throw e;
    }
}

export const getPointOfSalesInScope = async (providers) => {
    return providers
      .filter(provider => isProviderAPos(provider))
      .map(provider => provider.object)
}

export const reopenMerchantFromCompany = async (companyId, merchantId, status) => {
    return await call(METHODS.PUT, ROUTE_PREFIX, `${companyId}/pos/${merchantId}/busy`, {
        status
    } );
}
